
import { TimeseriesAnnotationsDataProvider } from './TimeseriesAnnotationsDataProvider.js';
import { TimeseriesChartXScaleProvider } from './TimeseriesChartXScaleProvider.js';
import { TimeseriesChartYScalesProvider } from './TimeseriesChartYScalesProvider.js';
import { TimeseriesFormatterProvider } from './TimeseriesFormatterProvider.js';
import { WithChildren } from '../../../core/types/with-children.js';

export const TimeseriesChartProviders = ({ children }: WithChildren) => (
  <TimeseriesChartXScaleProvider>
    <TimeseriesChartYScalesProvider>
      <TimeseriesFormatterProvider>
        <TimeseriesAnnotationsDataProvider>
          {children}
        </TimeseriesAnnotationsDataProvider>
      </TimeseriesFormatterProvider>
    </TimeseriesChartYScalesProvider>
  </TimeseriesChartXScaleProvider>
);

TimeseriesChartProviders['displayName'] = 'TimeseriesChartProviders';
